var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSidebarCollapseIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "10px",
    viewBox: "0 0 19 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-213.000000, -72.000000)",
    stroke: "#0049FF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.500000, 34.000000) scale(-1, 1) translate(-18.500000, -34.000000) translate(10.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 4,
    x2: 1.5,
    y2: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "12.5 0 16.5 4 12.5 8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    transform: "translate(2.500000, 4.000000) scale(-1, 1) translate(-2.500000, -4.000000) ",
    points: "0.5 0 4.5 4 0.5 8"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSidebarCollapseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sidebar-collapse-icon.99317c86.svg";
export { ForwardRef as ReactComponent };